var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.importObject)?_c('div',[_c('text-field',{attrs:{"label":_vm.$tc(_vm.$translate.Contractors)}},[_c('span',[_vm._v(_vm._s(_vm.count))])]),_c('text-field',{attrs:{"label":_vm.$tc(_vm.$translate.File)}},[(
        _vm.importObject &&
          _vm.importObject.importType.diskId &&
          _vm.importObject.importType.fileId
      )?_c('custom-button',{attrs:{"type":"link"},on:{"click":function($event){return _vm.downloadFile(
          _vm.importObject.importType.diskId,
          _vm.importObject.importType.fileId
        )}}},[_vm._v("\n      "+_vm._s(_vm.importObject.importType.fileName)+"\n    ")]):_c('span',[_vm._v(_vm._s(_vm.$t(_vm.$translate.NotFilled)))])],1),_c('import-error-list',{attrs:{"errors":_vm.importObject.errors}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }